import React from 'react';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import styles from './styles/pay-period-card.module.scss';
import { formatNumberWithCommas } from '../../../../utils/numbers';

// Enable the advanced format plugin for ordinal dates
dayjs.extend(advancedFormat);

function PayPeriodCard({ consumer }) {
    const endDatePart = consumer?.payPeriod?.split(' to ')[1];
    const startDatePart = consumer?.payPeriod?.split(' to ')[0];

    const endDateOnly = endDatePart?.split(' ')[0];
    const startDateOnly = startDatePart?.split(' ')[0];

    const endDate = dayjs(endDateOnly, 'DD-MM-YYYY').format('MMM Do, YYYY');
    const endDateShort = dayjs(endDateOnly, 'DD-MM-YYYY').format('MMM Do');
    const startDate = dayjs(startDateOnly, 'DD-MM-YYYY').format('MMM Do');

    const daysLeft =
        consumer.daysInCycle < consumer?.daysIn
            ? `${(consumer.daysIn - consumer.daysInCycle).toFixed(0)} days past due!`
            : `${consumer.daysInCycle - consumer.daysIn} days left`;

    const percentage = consumer.daysIn > consumer.daysInCycle ? 100 : (consumer.daysIn / consumer.daysInCycle) * 100;

    return (
        <div className={styles.card}>
            <div className={styles.titleContainer}>
                <div className={styles.titleLeft}>
                    <p className={styles.title}>Total Amount Due by {endDate}</p>
                    <p className={styles.subtitle}>The total amount that is to be deducted from the user’s account on pay day.</p>
                </div>
                <p className={styles.amount}>${formatNumberWithCommas(consumer?.totalAdvancedInPayPeriod, true)}</p>
            </div>
            <div className={styles.percentageInfo}>
                <p className={styles.payPeriod}>
                    Current Pay Period ({startDate} - {endDateShort})
                </p>
                <p className={styles.daysLeft}>{daysLeft}</p>
            </div>
            <div className={styles.percentageBar}>
                <div
                    className={styles.percentageBarInner}
                    style={{ backgroundColor: percentage >= 100 ? '#F34131' : '#4285F4', width: `${percentage}%` }}
                ></div>
            </div>
        </div>
    );
}

export default PayPeriodCard;
